export interface BoardRect {
  height: number;
  width: number;
  x: number;
  y: number;
}

export function buildSelectionRect(start: { x: number; y: number }, current: { x: number; y: number }) {
  const x = Math.min(start.x, current.x);
  const y = Math.min(start.y, current.y);

  return {
    height: Math.abs(current.y - start.y),
    width: Math.abs(current.x - start.x),
    x,
    y,
  };
}

export function rectsIntersect(selectionRect: BoardRect, elementRect: BoardRect) {
  const selectionBottom = selectionRect.y + selectionRect.height;
  const selectionRight = selectionRect.x + selectionRect.width;
  const elementBottom = elementRect.y + elementRect.height;
  const elementRight = elementRect.x + elementRect.width;

  return !(
    selectionBottom < elementRect.y ||
    selectionRect.y > elementBottom ||
    selectionRight < elementRect.x ||
    selectionRect.x > elementRight
  );
}
